import React from 'react';
import { cn } from '@/lib/utils';

function StatCard({ title, value, change, changeType, icon, subtitle, className }) {
  const changeColor =
    changeType === 'positive'
      ? 'text-green-400'
      : changeType === 'negative'
      ? 'text-red-400'
      : 'text-muted-foreground';

  return (
    <div
      className={cn(
        'rounded-xl border border-white/8 bg-card/40 backdrop-blur-md p-4 hover:border-primary/30 hover:shadow-[0_0_15px_-3px_rgba(34,197,94,0.15)] transition-all transition-transform hover:scale-[1.02]',
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <p className="text-xl font-bold text-foreground mb-1">{value}</p>
          {subtitle && <p className="text-xs text-muted-foreground/70">{subtitle}</p>}
          {change && (
            <p className={`text-sm font-medium mt-1 ${changeColor}`}>
              {changeType === 'positive' && '↑ '}
              {changeType === 'negative' && '↓ '}
              {change}
            </p>
          )}
        </div>
        {icon && <div className="text-2xl">{icon}</div>}
      </div>
    </div>
  );
}

export default StatCard;
